import { AppError } from "config/errors";
import { createDirectUploadToCloudMutation } from "gql/mutations/directUpload";
import { createMD5Checksum } from "utils/createFileChecksum";

import { createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       THUNKS      ------------------ */
export const createDirectUpload = createAsyncThunk(
  "createDirectUpload",
  async (file: File, { rejectWithValue }) => {
    try {
      const md5Checksum = await createMD5Checksum(file);

      const { data } = await createDirectUploadToCloudMutation({
        byteSize: file.size,
        checksum: md5Checksum,
        contentType: file.type,
        filename: file.name,
      });

      if (!data) {
        throw new AppError({
          code: "STANDARD_ERROR",
          fullMessage: "Failed to create direct upload",
        });
      }

      return data?.createDirectUploadToCloud.directUpload;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
